<template>
<div class="mdl-textfield mdl-js-textfield">
  <input
    class="mdl-textfield__input"
    type="number"
    :value="formattedValue"
    @keydown.enter.prevent="update"
    @blur="update"
    onfocus="this.select()"
    :disabled="disabled"
    v-focus
  >
</div>
</template>
<script>
import accounting from 'accounting'

export default {
  props: {
    value: {type: String, required: true},
    disabled: {type: Boolean}
  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  },
  data () {
    return {
      error: false
    }
  },
  computed: {
    formattedValue () {
      return Number(accounting.formatMoney(this.value.replace(',', '.'), '', 2, ' ', '.')).toFixed(2)
    }
  },
  methods: {
    update (event) {
      const newValue = accounting.formatMoney(event.target.value.replace(',', '.'), '', 2, ' ', '.')
      if (newValue !== this.value) {
        this.$emit('input', newValue)
      } else {
        event.target.value = this.formattedValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CurrencyInput.vue?168a2fe4